import { useEffect, useRef,useState} from "react";
import { getToken, getUserId } from "../auth";
import funzione_collegamento from "../funzioni_server/pacchetti_lez_function.js";
import  differenzaOrario  from "../funzioni/differenza_ore";
import "../stili/tabelle.css";
import "../stili/popup.css";
import "../stili/tabs.css"
import "../stili/agenda.css"
import convertDate from "../funzioni/converti_data";
import { DateTime } from 'luxon';
import nome_id from "../funzioni/nome_id.js"
import {convertiIdInventario,ordinaPerData,prendiNomePacchetto,coloreDaId,pacchettiAperti,materialeDisponibile,istruttori_disponibili,isoToString,convertiIdRuolo,convertiValuta} from "../funzioni/funzioni_utili"
import ReactDOM from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUsers, faPencil, faTrashCan,faCircleInfo,faSpinner,faCheck,faX } from "@fortawesome/free-solid-svg-icons";
import Lottie from "lottie-react";
import animLoading from "../assets/loading.json";
import status_lezione from "../funzioni/status_lezione"
/* global $ */
function Utenti(){
let periodi=null
    function handleClick(cellInfo,periodi) {
    const content=mostraDettagliUtente(cellInfo,periodi)
    $("#infoUtente").dxPopup("instance").option( "title",`Dettagli di ${cellInfo.data.nome}`);
    $("#infoUtente").dxPopup("instance").option("contentTemplate", () => content);
    $("#infoUtente").dxPopup("instance").show();
    }
    function mostraDettagliUtente(cellInfo,periodiT){
    let persona=cellInfo.data.userid
    const allineamento="center"
    const frequenze={"-1":"Assente",0:"Mensile",1:"Settimanale"}
        console.log(cellInfo,periodiT)
        let periodiUtente=[]
        for (let periodo of periodiT){
            if (periodo.userid===cellInfo.data.userid){
                periodiUtente=[...periodiUtente,periodo]
            }
        }
        const formattedRowsPeriodi=periodiUtente.map((row,index) => ({
            id:index,
            persona:row.userid,
            workperiodid:row.workperiodid,
            inizio:convertDate(row.workperioddatefrom).toISO({ includeOffset: false }),
            fine:convertDate(row.workperioddateto).toISO({ includeOffset: false }),
            pagaOraria:row.workperiodhourlypayment,
            pagaOrariaGruppi:row.workperiodhourlypaymentgroups,
            valuta:row.workperiodfixedsalarycurrency,
            fisso:row.workperiodfixedsalary,
            frequenza:row.workperiodfixedsalary!==0 ? row.workperiodfixedsalaryfreq : "-1",
            commissioni:row.workperiodcommissionrate,
            commissioniLez:row.workperiodcommissionratelesson,
            commissioniLezMateriale:row.workperiodcommissionratelessonmaterial,
            commissionRental:row.workperiodcommissionrental,
        }))
        const divGen = document.createElement("div");
        divGen.style.padding = "0px";
        divGen.id = "gridContainerUserDetails";
        setTimeout(() =>{
            $("#gridContainerUserDetails").dxDataGrid({
                dataSource:formattedRowsPeriodi,
                columns:[
                {
          dataField: "inizio",
          caption: "Inizio periodo di lavoro",
          hidingPriority:10,
          alignment:allineamento,
          customizeText: function (e) {
            return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy");
          },
          editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_inizio").length===0) {
                $('<div id="val_inizio"></div>').appendTo(cellElement)
            }
            $("#val_inizio").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value, onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            }})
          }
        },
        {
          dataField: "fine",
          caption: "Fine periodo di lavoro",
          hidingPriority:11,
          alignment:allineamento,
          customizeText: function (e) {
            return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy");
          },
          editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_fine").length===0) {
                $('<div id="val_fine"></div>').appendTo(cellElement)
            }
            $("#val_fine").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value, onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }

            }})
          }
        },
        {
          dataField: "fisso",
          caption: "Stipendio fisso",
          hidingPriority:8,
          alignment:allineamento,
          cellTemplate: (cellElement, cellInfo) => {
          if (cellInfo.value!==0){
            const root = ReactDOM.createRoot(cellElement.get(0));
            root.render(
        <div style={{ fontFamily: "Poppins, sans-serif" }}>
            {cellInfo.value}{convertiValuta(cellInfo.data.valuta)}
        </div>
    );
          }
          else{
              const icon = faX;
              const root = ReactDOM.createRoot(cellElement.get(0));
              root.render(
                  <FontAwesomeIcon icon={icon} />
              );}
            },
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_costo").length===0) {
                $('<div id="val_costo"></div>').appendTo(cellElement)
            }
            $("#val_costo").dxNumberBox({min:0,value:cellInfo.value,format:`#0.##'${cellInfo.data.valuta?convertiValuta(cellInfo.data.valuta):"€"}'`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)

            }})
          },
        },
        {
        dataField:"frequenza",
        caption: "Frequenza fisso",
          hidingPriority:5,
          alignment:allineamento,
          customizeText: function(e){
            return frequenze[e.value]
          },
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_frequenza").length===0) {
                $('<div id="val_frequenza"></div>').appendTo(cellElement)
            }
            const dati_ut=[{"id":0,"name":"Mensile"},{"id":1,"name":"Settimanale"}]
            $("#val_frequenza").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)

            }})
          },
        },
        {
          dataField: "pagaOraria",
          caption: "Paga lezioni singole",
          hidingPriority:9,
          alignment:allineamento,
          cellTemplate: (cellElement, cellInfo) => {
          if (cellInfo.value!==0){
            const root = ReactDOM.createRoot(cellElement.get(0));
            root.render(
        <div style={{ fontFamily: "Poppins, sans-serif" }}>
            {cellInfo.value}{convertiValuta(cellInfo.data.valuta)}
        </div>
    );
          }
          else{
              const icon = faX;
              const root = ReactDOM.createRoot(cellElement.get(0));
              root.render(
                  <FontAwesomeIcon icon={icon} />
              );}
            },
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_singole").length===0) {
                $('<div id="val_singole"></div>').appendTo(cellElement)
            }
            $("#val_singole").dxNumberBox({min:0,value:cellInfo.value,format:`#0.##'${cellInfo.data.valuta?convertiValuta(cellInfo.data.valuta):"€"}'`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)

            }})
          },
        },
        {
          dataField: "pagaOrariaGruppi",
          caption: "Paga lezioni di gruppo",
          hidingPriority:7,
          alignment:allineamento,
          cellTemplate: (cellElement, cellInfo) => {
          if (cellInfo.value!==0){
            const root = ReactDOM.createRoot(cellElement.get(0));
            root.render(
        <div style={{ fontFamily: "Poppins, sans-serif" }}>
            {cellInfo.value}{convertiValuta(cellInfo.data.valuta)}
        </div>
    );
          }
          else{
              const icon = faX;
              const root = ReactDOM.createRoot(cellElement.get(0));
              root.render(
                  <FontAwesomeIcon icon={icon} />
              );}
            },
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_doppie").length===0) {
                $('<div id="val_doppie"></div>').appendTo(cellElement)
            }
            $("#val_doppie").dxNumberBox({min:0,value:cellInfo.value,format:`#0.##'${cellInfo.data.valuta?convertiValuta(cellInfo.data.valuta):"€"}'`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)

            }})
          },
        },
        {
          dataField: "commissioniLez",
          caption: "Commissioni Lezioni Avanzate",
          hidingPriority:4,
          alignment:allineamento,
          cellTemplate: (cellElement, cellInfo) => {
          if (cellInfo.value!==0){
            const root = ReactDOM.createRoot(cellElement.get(0));
            root.render(
        <div style={{ fontFamily: "Poppins, sans-serif" }}>
            {cellInfo.value}%
        </div>
    );
          }
          else{
              const icon = faX;
              const root = ReactDOM.createRoot(cellElement.get(0));
              root.render(
                  <FontAwesomeIcon icon={icon} />
              );}
            },
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_commiss_av").length===0) {
                $('<div id="val_commiss_av"></div>').appendTo(cellElement)
            }
            $("#val_commiss_av").dxNumberBox({min:0,value:cellInfo.value,format:`#0.##'%'`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)

            }})
          },
        },
        {
          dataField: "commissioniLezMateriale",
          caption: "Commissioni Lezioni Avanzate con Materiale",
          hidingPriority:3,
          alignment:allineamento,
          cellTemplate: (cellElement, cellInfo) => {
          if (cellInfo.value!==0){
            const root = ReactDOM.createRoot(cellElement.get(0));
            root.render(
        <div style={{ fontFamily: "Poppins, sans-serif" }}>
            {cellInfo.value}%
        </div>
    );
          }
          else{
              const icon = faX;
              const root = ReactDOM.createRoot(cellElement.get(0));
              root.render(
                  <FontAwesomeIcon icon={icon} />
              );}
            },
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_commiss_av_mat").length===0) {
                $('<div id="val_commiss_av_mat"></div>').appendTo(cellElement)
            }
            $("#val_commiss_av_mat").dxNumberBox({min:0,value:cellInfo.value,format:`#0.##'%'`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)

            }})
          },
        },
        {
          dataField: "commissioni",
          caption: "Commissioni escursioni",
          hidingPriority:2,
          alignment:allineamento,
          cellTemplate: (cellElement, cellInfo) => {
          if (cellInfo.value!==0){
            const root = ReactDOM.createRoot(cellElement.get(0));
            root.render(
        <div style={{ fontFamily: "Poppins, sans-serif" }}>
            {cellInfo.value}%
        </div>
    );
          }
          else{
              const icon = faX;
              const root = ReactDOM.createRoot(cellElement.get(0));
              root.render(
                  <FontAwesomeIcon icon={icon} />
              );}
            },
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_commiss").length===0) {
                $('<div id="val_commiss"></div>').appendTo(cellElement)
            }
            $("#val_commiss").dxNumberBox({min:0,value:cellInfo.value,format:`#0.##'%'`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)

            }})
          },
        },
        {
          dataField: "commissionRental",
          caption: "Paga noleggi assistiti",
          hidingPriority:1,
          alignment:allineamento,
          cellTemplate: (cellElement, cellInfo) => {
          if (cellInfo.value!==0){
            const root = ReactDOM.createRoot(cellElement.get(0));
            root.render(
        <div style={{ fontFamily: "Poppins, sans-serif" }}>
            {cellInfo.value}{convertiValuta(cellInfo.data.valuta)}
        </div>
    );
          }
          else{
              const icon = faX;
              const root = ReactDOM.createRoot(cellElement.get(0));
              root.render(
                  <FontAwesomeIcon icon={icon} />
              );}
            },
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_noleggi").length===0) {
                $('<div id="val_noleggi"></div>').appendTo(cellElement)
            }
            $("#val_noleggi").dxNumberBox({min:0,value:cellInfo.value,format:`#0.##'${cellInfo.data.valuta?convertiValuta(cellInfo.data.valuta):"€"}'`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)

            }})
          },
        },
        {
        dataField:"valuta",
        caption: "Valuta stipendi",
          hidingPriority:6,
          alignment:allineamento,
          customizeText: function(e){
            return convertiValuta(e.value)
          },
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_valuta").length===0) {
                $('<div id="val_valuta"></div>').appendTo(cellElement)
            }
            let dati_ut=[]
              let contatore=0
              while (convertiValuta(contatore)){
                dati_ut.push({name:convertiValuta(contatore),id:contatore})
                  contatore+=1
              }
            $("#val_valuta").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            $("#val_costo").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
            $("#val_singole").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
            $("#val_doppie").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
            }})
          },
        },
        {
            type: "buttons",
            width:"120px",
            buttons: [
              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => cellInfo.component.editRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
              {
                hint: "Elimina",
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },

              ]}

                ],
        onRowRemoving: async function (e) {
    const richiesta=  await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        delId:e.data.workperiodid,
        azione:'delUserWorkPeriod',
        return_data:false})
    if (richiesta) {
        const message = `Periodo eliminato con successo`;
        window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainerUserDetails',
        },}, "success", 1000);}


},

    onRowInserting: async function (e) {

        // Aggiungi la classe di animazione alla griglia
        $("#loadingOverlay").show();
         $("#gridContainerUserDetails").addClass("grid-container-hidden");

        // Rimuovi la classe dopo l'animazione
    const dati_n={'userid':persona,"workperiodcommissionratelesson":e.data.commissioniLez,"workperiodcommissionratelessonmaterial":e.data.commissioniLezMateriale,'workperioddatefrom':convertDate(DateTime.fromISO(e.data.inizio)),'workperioddateto':convertDate(DateTime.fromISO(e.data.fine)),'workperiodhourlypayment':e.data.pagaOraria?e.data.pagaOraria:0,'workperiodhourlypaymentgroups':e.data.pagaOrariaGruppi?e.data.pagaOrariaGruppi:0,'workperiodfixedsalarycurrency':e.data.valuta?e.data.valuta:0,'workperiodfixedsalary':e.data.fisso? e.data.fisso:0,"workperiodfixedsalaryfreq":typeof e.data.frequenza==="number"?e.data.frequenza:0,"workperiodcommissionrental":e.data.commissionRental,"workperiodcommissionrate":e.data.commissioni?e.data.commissioni:0,};
    const richiesta= await  funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        valori:dati_n,
        azione:'setUserWorkPeriod'})
    if (richiesta) {
        const message = `Periodo aggiunto con successo`;

  window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainerUserDetails',
        },}, "success", 1000);
                periodi= await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    azione: "getUserWorkPeriods",
                })
                let periodiUtente=[]
        for (let periodo of periodi){
            if (periodo.userid===cellInfo.data.userid){
                periodiUtente=[...periodiUtente,periodo]
            }
        }
                const formattedRowsPeriodi=periodiUtente.map((row,index) => ({
            id:index,
            persona:row.userid,
            workperiodid:row.workperiodid,
            inizio:convertDate(row.workperioddatefrom).toISO({ includeOffset: false }),
            fine:convertDate(row.workperioddateto).toISO({ includeOffset: false }),
            pagaOraria:row.workperiodhourlypayment,
            pagaOrariaGruppi:row.workperiodhourlypaymentgroups,
            valuta:row.workperiodfixedsalarycurrency,
            fisso:row.workperiodfixedsalary,
            frequenza:row.workperiodfixedsalary!==0 ? row.workperiodfixedsalaryfreq : "-1",
            commissioni:row.workperiodcommissionrate,
            commissioniLez:row.workperiodcommissionratelesson,
            commissioniLezMateriale:row.workperiodcommissionratelessonmaterial,
            commissionRental:row.workperiodcommissionrental,
        }))
      e.component.option("dataSource", formattedRowsPeriodi);
      setTimeout(() => {
            $("#gridContainerUserDetails").removeClass("grid-container-hidden");
            $("#loadingOverlay").hide();
        }, 100);
        }
    },
    onRowUpdated: async function (e) {
    const gridElement = $("#gridContainerUserDetails"); // Ottieni l'intera griglia

        // Aggiungi la classe di animazione alla griglia
        gridElement.addClass("table-updated");

        // Rimuovi la classe dopo l'animazione
        setTimeout(() => {
            gridElement.removeClass("table-updated");
        }, 1000);
    const dati_n={'userid' :persona,"workperiodcommissionratelesson":e.data.commissioniLez,"workperiodcommissionratelessonmaterial":e.data.commissioniLezMateriale,'workperioddatefrom':convertDate(DateTime.fromISO(e.data.inizio)),'workperioddateto':convertDate(DateTime.fromISO(e.data.fine)),'workperiodhourlypayment':e.data.pagaOraria?e.data.pagaOraria:0,'workperiodhourlypaymentgroups':e.data.pagaOrariaGruppi?e.data.pagaOrariaGruppi:0,'workperiodfixedsalarycurrency':e.data.valuta?e.data.valuta:0,'workperiodfixedsalary':e.data.fisso? e.data.fisso:0,"workperiodfixedsalaryfreq":typeof e.data.frequenza==="number"?e.data.frequenza:0,"workperiodcommissionrental":e.data.commissionRental,"workperiodcommissionrate":e.data.commissioni?e.data.commissioni:0,};
    const richiesta = await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        setId:e.data.workperiodid,
        valori:dati_n,
        azione:'setUserWorkPeriod'})
        if (richiesta) {
        const message = `Periodo modificato con successo`;

  window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainerUserDetails',
        },}, "success", 1000);
        }
    },
        showBorders: true,
      scrolling: { useNative: true },
      rowAlternationEnabled: true,
      columnAutoWidth: true,
      paging: { pageSize: 50 },
      height: "auto",
      width: "auto",
      columnHidingEnabled: true,
      editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            width:"70%",
            height:"auto",
            maxHeight:"90%",
            title: `Modifica utente`,
            showTitle: true,
          },
          form: {
            items: [
              {
                itemType: "group",
                colCount: 2,
                colSpan: 2,
                items: [
                "inizio","fine","fisso","frequenza","pagaOraria","pagaOrariaGruppi","commissioni","commissioniLez","commissioniLezMateriale","commissionRental","valuta"
                ],
              },
            ],
          },
      },
            })
        },0)
        return divGen

    }
    function BounceIconButton({ icon, onClick, color = "#000" }) {
      const [isClicked, setIsClicked] = useState(false);


      const handleClick = () => {
        setIsClicked(true);
        setTimeout(() => setIsClicked(false), 800);
        onClick();
      };

      return (
        <button
          style={{
            cursor: "pointer",
            padding: "5px",
            background: "none",
            border: "none",
            color: color,
          }}
          onClick={handleClick}
        >
          <FontAwesomeIcon icon={icon} className={isClicked ? "fa-bounce" : ""} />
        </button>
      );
    }
    function UtentiTabella() {
        const tipoStorag=[{id:1,text:"Storage"},{id:2,text:"Storage + 3 rescue"},{id:3,text:"Assistenza spiaggia"}]
        const allineamento="center"
        useEffect(() => {
            const fetchUtenti = async () => {
                $("#gridContainerUsers").addClass("grid-container-hidden")
                $("#loadingOverlay").show()
                const dati = await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    azione: "getUsers",
                })
                 periodi= await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    azione: "getUserWorkPeriods",
                })

                const formattedRows=dati.map((row,index) => ({
                    id:index,
                    userid:row.userid,
                    nome:row.name,
                    cognome:row.surname,
                    email:row.email,
                    attivo:row.enabled,
                    ruolo:row.type,
                    tel1:row.phonenumber1,
                    tel2:row.phonenumber2,
                    nomeUtente:row.user,
                    password:row.pwd,
                    ultimaConnessione:row.lastconnected,
                }))
                const tabella= $("#gridContainerUsers").dxDataGrid({
                dataSource:formattedRows,
                columns:[
        {
          dataField: "nome",
          caption: "Nome",
          hidingPriority:9,
          alignment:allineamento,

        },
        {
          dataField: "cognome",
          caption: "Cognome",
          hidingPriority:10,
          alignment:allineamento,

        },
        {
          dataField: "ruolo",
          caption: "Ruolo",
          hidingPriority:8,
          alignment:allineamento,
          customizeText: function (e){
            return convertiIdRuolo(e.value)
          },
          editCellTemplate: function  (cellElement,cellInfo) {
          if ($("#val_ruolo").length===0) {
                $('<div id="val_ruolo"></div>').appendTo(cellElement)
            }
             const rowData = cellInfo.row.data;
             let dati_ut=[]
             for (let i = 0; i <= 5; i++) {
              dati_ut=[...dati_ut,{ID:i,nome:convertiIdRuolo(i)}]
            }
            $("#val_ruolo").dxSelectBox({dataSource:dati_ut , displayExpr:"nome",value:cellInfo.value,valueExpr:"ID",onValueChanged: function(e) {
            cellInfo.setValue(e.value)},
            elementAttr: {
                class: "istruttore-style"
              },
            })
          },
        },
        {
          dataField: "email",
          caption: "Email",
          hidingPriority:7,
          alignment:allineamento,

        },
        {
          dataField: "tel1",
          caption: "Numero di telefono 1",
          hidingPriority:4,
          alignment:allineamento,

        },
        {
          dataField: "tel2",
          caption: "Numero di telefono 2",
          hidingPriority:3,
          alignment:allineamento,

        },
        {
          dataField: "nomeUtente",
          caption: "Nome utente",
          hidingPriority:6,
          alignment:allineamento,

        },

        {
          dataField: "password",
          caption: "Password",
          hidingPriority:5,
          alignment:allineamento,

        },
        {
          dataField: "ultimaConnessione",
          caption: "Ultima connessione",
          hidingPriority:1,
          alignment:allineamento,
          customizeText: function (e) {
          if (e.value)
            return convertDate(e.value).toFormat("dd/MM/yyyy, HH:mm")
          else return ""
          }

        },
        {
          dataField: "attivo",
          caption: "Profilo attivo",
          hidingPriority:2,
          alignment:allineamento,
          cellTemplate: (cellElement, cellInfo) => {
              const icon = cellInfo.value === 1 ? faCheck : faX;
              const root = ReactDOM.createRoot(cellElement.get(0));
              root.render(
                  <FontAwesomeIcon icon={icon} />
              );
            },
          editCellTemplate: function(cellElement,cellInfo) {
          if ($("#val_util").length===0) {
                $('<div id="val_util"></div>').appendTo(cellElement)
            }
          $("#val_util").dxCheckBox({value:cellInfo.value, onValueChanged: function(e) {
            if (e.value)
            cellInfo.setValue(1)
            else
            cellInfo.setValue(0)
            },
            })
          },
        },

        {
            type: "buttons",
            width:"120px",
            buttons: [
              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => cellInfo.component.editRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
              {
                hint: "Elimina",
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
              {
                hint: "Dettagli Perido",
                icon: "none",
                template: function (cellElement, cellInfo,) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faCircleInfo}
                      color="#03a9f4"
                      onClick={() => handleClick(cellInfo,periodi)}
                    />
                  );
                },
              }
              ]}
      ],
      onRowRemoving: async function (e) {
    const richiesta=  await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        delId:e.data.userid,
        azione:'delUser',
        return_data:false})
    if (richiesta) {
        const message = `Utente eliminato con successo`;
        window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainerUsers',
        },}, "success", 1000);}


},

    onRowInserting: async function (e) {

        // Aggiungi la classe di animazione alla griglia
        $("#loadingOverlay").show();
         $("#gridContainerUsers").addClass("grid-container-hidden");

        // Rimuovi la classe dopo l'animazione

    const dati_n={'pwd':e.data.password,'user':e.data.nomeUtente,'name':e.data.nome,'surname':e.data.cognome,'phonenumber1':e.data.tel1,'phonenumber2':e.data.tel2,"enabled":e.data.attivo,"email":e.data.email,"type":e.data.ruolo};
    const richiesta= await  funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        valori:dati_n,
        azione:'setUser'})
    if (richiesta) {
        const message = `Utente aggiunto con successo`;

  window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainerUsers',
        },}, "success", 1000);
        const dati = await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    azione: "getUsers",
                })
                 periodi= await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    azione: "getUserWorkPeriods",
                })

                const formattedRows=dati.map((row,index) => ({
                    id:index,
                    userid:row.userid,
                    nome:row.name,
                    cognome:row.surname,
                    email:row.email,
                    attivo:row.enabled,
                    ruolo:row.type,
                    tel1:row.phonenumber1,
                    tel2:row.phonenumber2,
                    nomeUtente:row.user,
                    password:row.pwd,
                    ultimaConnessione:row.lastconnected,
                }))
      e.component.option("dataSource", formattedRows);
      setTimeout(() => {
            $("#gridContainerUsers").removeClass("grid-container-hidden");
            $("#loadingOverlay").hide();
        }, 100);
        }
    },
    onRowUpdated: async function (e) {
    const gridElement = $("#gridContainerUsers"); // Ottieni l'intera griglia

        // Aggiungi la classe di animazione alla griglia
        gridElement.addClass("table-updated");

        // Rimuovi la classe dopo l'animazione
        setTimeout(() => {
            gridElement.removeClass("table-updated");
        }, 1000);
    const dati_n={'pwd':e.data.password,'user':e.data.nomeUtente,'name':e.data.nome,'surname':e.data.cognome,'phonenumber1':e.data.tel1,'phonenumber2':e.data.tel2,"enabled":e.data.attivo,"email":e.data.email,"type":e.data.ruolo};
    const richiesta = await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        setId:e.data.userid,
        valori:dati_n,
        azione:'setUser'})
        if (richiesta) {
        const message = `Utente modificato con successo`;

  window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainerUsers',
        },}, "success", 1000);
        }
    },
        onRowPrepared: function (e) {
            setTimeout(() => {
                $("#gridContainerUsers").removeClass("grid-container-hidden");
                $("#loadingOverlay").hide();},500)

        },

      showBorders: true,
      scrolling: { useNative: true },
      rowAlternationEnabled: true,
      columnAutoWidth: true,
      paging: { pageSize: 50 },
      height: "auto",
      width: "auto",
      columnHidingEnabled: true,
      editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            width:"70%",
            height:"auto",
            maxHeight:"90%",
            title: `Modifica utente`,
            showTitle: true,
          },
          form: {
            items: [
              {
                itemType: "group",
                colCount: 2,
                colSpan: 2,
                items: [
                "nome","cognome","ruolo","email","tel1","tel2","nomeUtente","password","attivo"
                ],
              },
            ],
          },
      },
                })
            $("#infoUtente").dxPopup({
    width: "80%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
    resizeEnabled: true,
    closeOnOutsideClick: true,
    showCloseButton: true,
    onShown: function(e) {
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScrollUtente" style="height: 100%;"></div>');
    $("#customScrollUtente").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    });
    }})
            }
        fetchUtenti()
        },[])
        return (<div id="gridContainerUsers" ></div>)
    }
    return <div>
           <UtentiTabella/>
           <div id="infoUtente"></div>
           <div id="loadingOverlay">
           <div className="spinner">
              <Lottie  style={{ width: "30%", height: "30%" }} animationData={animLoading} loop={true} />
           </div>
        </div>
           </div>
}
export default Utenti;